<template>
  <h1 >RFID Processing - Order  <router-link :to="{ name: 'ViewOrder', params: { id: currentOrderId } }" target="_blank" class="white">{{ currentOrderId }}</router-link></h1>
  <audio src="/resources/audio/rogue.wav" autostart="false" loop="false" hidden="true" width="0" height="0" id="audio_rogue" />

  <div id="page-rfid-dashboard" class="content-section">
    <div class="page-section">

      <div class="content-section">
        <div class="row">
          <div class="col-md-3 right-pipeline">
            <div> <b>Customer Name:</b>  <router-link target="_blank" :to="{ name: 'ViewCustomer', params: { id: orderDetails.customer_id } }">{{orderDetails.customername}}
              </router-link> </div>
            <div> <b>Location:</b> {{orderDetails.locationname}} </div>
          </div>
          <div class="col-md-3 right-pipeline">
            <div> <b>Placed on:</b> {{formatFullDateEN(orderDetails.timeplaced)}} via {{orderDetails.ordermethod}}</div>
            <div> <b>by EPOS user:</b> {{ orderDetails.order_status_log?.epos_user_name || '' }}</div>
          </div>
          <div class="col-md-3 right-pipeline">
            <div> <b>Collection Date:</b> <a href="#" @click.prevent="openUpdateDateModal('datecollect')">
    {{ formatDateEN(orderDetails.datecollect) }}</a> </div>
            <div> <b>Due Date:</b> <a href="#" @click.prevent="openUpdateDateModal('datedue')">
    {{ formatDateEN(orderDetails.datedue) }}</a></div>
          </div>
          <div class="col-md-3">
            <div> <b>Status:</b>  <a href="#" @click.prevent="showOrderHistory">{{ orderDetails.order_status?.pro_status_type || 'Awaiting collection' }}</a></div>
          </div>
        </div>
      </div>

      <div class="clearfix"></div>
      
      <div class="content-section">
        <div class="row">
          <div class="col-md-3">
            <div>
              <FormKit
                  type="button"
                  label="Go Back"
                  input-class="$reset btn-rfid-lg btn btn-rfid btn-process btn-goback"
                  @click="goTo('Dashboard')"
                  prefix-icon="arrowLeft"
                  prefix-icon-class="btn-rfid-back"
              />
            </div>
          </div>

          <div class="col-md-3">
            <div>
              <FormKit
                  type="button"
                  label="Start Scan"
                  input-class="$reset btn-rfid-lg btn btn-rfid btn-re-assign"
                  @click="goTo('StartScan')"
                  :disabled="!canStartScan ? true : false"
                  :help="`Default ${defaultmilisecondsgap} milliseconds gap between scans`"
              />
            </div>

          </div>

          <div class="col-md-3">
            <div>
              <FormKit
                  type="button"
                  label="Stop Scan"
                  input-class="$reset btn-rfid-lg btn btn-rfid btn-assemble"
                  @click="goTo('StopScan')"
                  :disabled="!canStopScan ? true : false"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div>
              <FormKit
                  type="button"
                  label="Reset"
                  input-class="$reset btn-rfid-lg btn btn-rfid btn-associate"
                  @click="goTo('Reset')"
                  :disabled="!canReset ? true : false"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="clearfix"></div>

      <div class="content-section">
        <div class="row">
          <div class="col-md-6">
            <label>Scanned Items - count {{countScannedItems}}</label>
            <div class="alert alert-info" v-if="alreadyInOrder">Some or all of the items that you scanned are already in the order.</div>
            <div style="max-height: 500px; overflow: auto;">
              <easy-data-table
                  :headers="headers"
                  :items="sortedItems"
                  :rows-per-page="99999"
                  alternating
                  border-cell
                  hide-footer
              >

              </easy-data-table>
            </div>
          </div>
          <div class="col-md-6">
            <label>Rogue Scanned Items - count {{countRogueScannedItems}}</label>
            <div style="max-height: 500px; overflow: auto;">
              <easy-data-table
                  :headers="headers"
                  :items="sortedRogueItems"
                  :rows-per-page="99999"
                  alternating
                  border-cell
                  hide-footer
              >

              </easy-data-table>
            </div>
          </div>
        </div>
      </div>

      <div class="clearfix"></div>
      
      <div class="content-section">
         <div class="row">
          <div class="alert alert-danger" v-if="showProcessErrors">
              <div v-html="processErrors"></div>
            </div>
          <div class="alert alert-success" v-if="showProcessMessage">
              <div v-html="processMessage"></div>
            </div>
           <div class="col-md-3">
            <FormKit
                type="button"
                label="Process Complete"
                input-class="$reset btn-rfid-lg btn btn-rfid btn-process"
                :disabled="!canProcess ? true : false"
                @click="goTo('ProcessOrder')"
            />
           </div> 
           
        </div>
      </div>
    </div>
  </div>


  <div class="modal" tabindex="-1" id="showAlertMessagesModal" ref="showAlertMessagesModal" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Attention!</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-if="confirmComplete">
            <div class="alert alert-warning">
              <div>Please make sure the conveyor is empty and all the towels are scanned!</div>
            </div>
          </div>
          <div v-else-if="!processComplete">
            <div class="alert alert-danger" v-if="error_message">
              <div v-html="error_message"></div>
            </div>
            <FormKit
                v-model="uniquepw"
                type="password"
                name="uniquepw"
                id="uniquepw"
                label="Pin"
                placeholder="Pin"
                validation="required"
            />
          </div>
          <div v-else>
            <div class="alert alert-success">
              <div>Successfully processed, redirect to:</div>
            </div>
            
          </div>
        </div>
        <div class="modal-footer">
          <div v-if="confirmComplete">
            <div style="  float: left;">
              <button type="button" class="btn btn-rfid-sm btn-danger" data-bs-dismiss="modal">Cancel</button>
            </div>
            <div style="  float: right;margin-left: 30px;">
              <button type="button" class="btn btn-rfid-sm btn-process"  @click="confirmCompleteAction">Next</button>
            </div>
          </div>
          <div v-else-if="!processComplete">
            <div style="  float: left;">
               <button type="button" class="btn btn-rfid-sm btn-danger" data-bs-dismiss="modal">Cancel</button>
            </div>
            <div style="  float: left;margin-left: 30px;">
              <button type="button" class="btn btn-rfid-sm btn-process"  @click="processOrderAction">Process</button>
            </div>
          </div>
          <div v-else>
             <div style="  float: left;">
              <button type="button" class="btn btn-rfid-sm btn-re-assign"  @click="printWhiteTicket">Print Ticket</button>
            </div>
            <div style="  float: left;margin-left: 30px;">
              <button type="button" class="btn btn-rfid-sm btn-primary"  @click="goTo('EposOrder')">{{ currentOrderId }}</button>
            </div>
            <div style="  float: right;margin-left: 30px;">
              <button type="button" class="btn btn-rfid-sm btn-rogues"  @click="goTo('RogueTransactions')">Rogue Transactions</button>
            </div>
            <div style="  float: right;margin-left: 30px;">
              <button type="button" class="btn btn-rfid-sm btn-process"  @click="goTo('Dashboard')">RFID Processing</button>
            </div>
          </div>
          
          
        </div>
      </div>
    </div>
  </div>

  <div class="modal" tabindex="-1" id="showUpdateOrderModal" ref="showUpdateOrderModal" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Update Order Data</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div>
            <div class="alert alert-danger" v-if="error_message">
              <span v-html="error_message">
              </span>
              &#160;
              <button v-if="forcePermitted" type="button" class="btn btn-danger"
                      @click="confirmOrderUpdate">
                Confirm
              </button>
            </div>
            <div v-if="updateDateType == 'datecollect'">
              <FormKit
                  v-model="orderDetails.datecollect"
                  name="datecollect"
                  type="datepicker"
                  label="Collection Date"
                  format="DD/MM/YYYY"
                  timezone="Europe/London"
                  clearable
                  :key="datepickerClearedKey"
              />
            </div>
            <div v-if="updateDateType == 'datedue'">
              <FormKit
                v-model="orderDetails.datedue"
                name="datedue"
                type="datepicker"
                label="Due Date"
                format="DD/MM/YYYY"
                timezone="Europe/London"
                clearable
                :key="datepickerClearedKey"
            />
            </div>
            
            <FormKit
                v-model="uniquepw"
                type="password"
                name="uniquepw"
                id="uniquepwDate"
                label="Manager Pin"
                placeholder="Manager Pin"
                validation="required"
            />
          </div>
        </div>
        <div class="modal-footer">
          <div style="  float: left;">
              <button type="button" class="btn btn-primary"  @click="updateOrderAction">Update</button>
            </div>
            <div style="  float: right;margin-left: 30px;">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            </div>
          
        </div>
      </div>
    </div>
  </div>

  <div class="modal" tabindex="-1" id="showOrderHistoryModal" ref="showOrderHistoryModal" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Order Status History</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
           <div v-if="orderStatusItems && orderStatusItems.length">
              <div v-for="(item, idx) in orderStatusItems" :key="idx">
                <div>{{ item.status }}: {{ item.date }}, {{ item.user }}</div>
              </div>
            </div>
        </div>
        <div class="modal-footer">
          <div style="  float: right;margin-left: 30px;">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script setup>

import {onMounted, ref, computed, inject, reactive, watch} from 'vue'
import { useRouter } from 'vue-router'
import 'bootstrap/dist/css/bootstrap.min.css';
import OrderService from '@/services/OrderService';
import RFIDService from "@/services/RFIDService";
import VueCookies from "vue-cookies";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle";
import { formatLondon,formatDateEN, formatFullDateEN, formatDateYMD } from '@/utils/dateUtils';
import { closeModal, openModal } from '@/utils/modalUtils';

const router = useRouter();

const currentOrderId = parseInt(router.currentRoute.value.params.id);
const defaultmilisecondsgap  = ref(20);

const canStartScan  = ref(true);
const canStopScan  = ref(false);
const canReset  = ref(false);
const canProcess  = ref(false);
const newBatchId = ref(1);

const alertMessage = ref('');
const error_message = ref('');
const showAlertMessagesModal = ref(null);
const alreadyInOrder = ref(false);
const showUpdateOrderModal = ref(null);
const showOrderHistoryModal = ref(null);
const datepickerClearedKey = ref(0);
const updateDateType = ref("");
const uniquepw = ref("");
const orderStatusItems = ref({});
const processComplete = ref(false);
const confirmComplete = ref(true);

const showProcessMessage = ref(false);
const processMessage = ref("");
const showProcessErrors = ref(false);
const processErrors = ref("");
const showSseErrors = ref(false);
const sseErrors = ref("");
var eventSource = {
  close: function() {
    console.log('initialized');
  }
};
const tagsScanned =  ref([]);
const scannedItems =  ref([]);
const rogueScanItems =  ref([]);
const orderDetails =  ref({});
const countScannedItems = ref(0);
const countRogueScannedItems = ref(0);

const forcePermitted = ref(false);

const sortedItems = computed(() =>
    [...scannedItems.value].sort((a, b) => b.garmentindex - a.garmentindex)
);
const sortedRogueItems = computed(() =>
    [...rogueScanItems.value].sort((a, b) => b.garmentindex - a.garmentindex)
);
const headers = [
  { text: "Index", value: "garmentindex", sortable: false  },
  { text: "EPC Scanned", value: "epcscanned", sortable: false },
  { text: "Garment ID", value: "tag_value", sortable: false },
  { text: "Garment Type", value: "garment_type", sortable: false },
  { text: "Timestamp", value: "tagtimestamp", sortable: false, align: "d-none" },
];
const playSound = (soundtype) => {
  let sound = document.getElementById("audio_"+soundtype);
  sound.currentTime = 0;
  sound.loop = false;
  sound.play();
}
function pingSession() {
  let userId = VueCookies.get('epos2_userid');
  let idToken = VueCookies.get('epos2_token');
  let userWorkstation = VueCookies.get('epos2_workstationid');

  VueCookies.set('epos2_token',idToken);
  VueCookies.set('epos2_userid',userId);
  VueCookies.set('epos2_workstationid',userWorkstation);
  console.log('API called at', new Date());
}

function openUpdateDateModal(type) {
  updateDateType.value = type;
   openModal(showUpdateOrderModal);
}

const handleScan = async (sseData) => {
  
  console.log("handleScan", sseData);
  alreadyInOrder.value = false;
  if (sseData.success == false) {
     if (sseData.code != "DUPLICATE_ITEM") {
      let rindex = rogueScanItems.value.length + parseInt(1);
      rogueScanItems.value.push({
        garmentindex: rindex,
        epcscanned: sseData.tag,
        tagtimestamp: formatLondon(sseData.timestamp),
        garment_id: sseData.data.garment_id,
        tag_value: sseData.data.tag_value,
        garment_type: sseData.data.garment_type + ' - '+ sseData.data.customer_name,
      });
      countRogueScannedItems.value = rogueScanItems.value.length;
      playSound('rogue');
      console.log("countRogueScannedItems.value");
    }else {
      console.log("Duplicate item scanned");
      alreadyInOrder.value = true;
       setTimeout(() => {
        alreadyInOrder.value = false;
      }, 3000); // hides after 3 seconds
    }
  } else {
      let sindex = scannedItems.value.length + parseInt(1);
      scannedItems.value.push({
          garmentindex: sindex,
          epcscanned: sseData.tag,
          tagtimestamp: formatLondon(sseData.timestamp),
          garment_id: sseData.data.garment_id,
          tag_value: sseData.data.tag_value,
          garment_type: sseData.data.garment_type,
        });
      countScannedItems.value = scannedItems.value.length;
    
  }
};

// Function to handle stream events from the server and process the incoming RFID tags
const startServerStream = async() => {
  sseErrors.value = "";
  const authToken = VueCookies.get('epos2_token');

  eventSource = new EventSource(process.env.VUE_APP_GO_API_BASE+"/api/rfid/stream?token=" + authToken+
      "&order_id=" + currentOrderId+"&new_batch=" +newBatchId.value);
    //eventSource = new EventSource(process.env.VUE_APP_GO_API_BASE+"/api/rfid/stream?token=" + authToken+
     //  "&order_id=" + currentOrderId);
  eventSource.onmessage = (event) => {

    //extend cookies expiration
    pingSession();

    if (event.data && event.data.includes('heartbeat')) {
      // Handle heartbeat event
      sseErrors.value = "";
      showSseErrors.value = false;

      return; // Don't process as normal data
    }
    const sseData = JSON.parse(event.data);
   
      showSseErrors.value = false;
      sseErrors.value = "";
      //remove duplicates (same tag)
      //let tagCheck = tagsScanned.value.findIndex((item) => item.epcscanned === sseData.tag);
      //if (tagCheck === -1) {
      if (!tagsScanned.value.includes(sseData.tag)) {
        tagsScanned.value.push(sseData.tag);
        handleScan(sseData);
      } else {
        console.log("Tag already exists");
      }
  };
  eventSource.onerror = function(error) {
    //playSound('error');
    console.error("Error:", error);
    sseErrors.value =  "An error occurred. Session still active?";
    showSseErrors.value = true;
  };
  eventSource.addEventListener("open", function(event) {
    console.log("Stream connection opened");
  });
}
const setStartScan = () => {
  console.log("start scan");
  //call goapi endpoint in order to start the scan
  canStartScan.value = false;
  canProcess.value = false;
  canStopScan.value = true;
  canReset.value = true;
  showProcessMessage.value = false;
  processMessage.value = "";
  showProcessErrors.value = false;
  processErrors.value = "";
}
const startScan = async () => {
  console.log("start scan");
  //call goapi endpoint in order to start the scan
  canStartScan.value = false;
  canProcess.value = false;
  canStopScan.value = true;
  canReset.value = true;
  showProcessMessage.value = false;
  processMessage.value = "";
  showProcessErrors.value = false;
  processErrors.value = "";

  startServerStream();

  //start the reader to read the tags
  RFIDService.startScan(currentOrderId)
      .then(response => {
      })
      .catch(e => {
        console.log(e);
      });
}
const setStopScan = () => {
  console.log("stop scan");
  canStartScan.value = true;
  canStopScan.value = false;
  canProcess.value = true;
  showSseErrors.value = false;
  sseErrors.value = "";
}
const stopScan = async () => {
  newBatchId.value = 0;
  console.log("Stop scan");
 
  //call goapi endpoint in order to stop the reader and finish to populate the table of founded tags
 
  //if(eventSource && eventSource.readyState === 1){
  if(eventSource){
    eventSource.close()
  }
 
  RFIDService.stopScan(currentOrderId)
      .then(response => {

      })
      .catch(e => {
        console.log(e);
      });
}
const setResetScan = () => {
  console.log("reset scan");
  setStopScan();
  stopScan();

  canStopScan.value = false;
  canStartScan.value = true;

  canProcess.value = false;

  showProcessMessage.value = false;
  processMessage.value = "";
  showProcessErrors.value = false;
  processErrors.value = "";
  
}
const resetScan = async () => {
  //stop the scan and clear the page
  
  newBatchId.value = 1;
  let garmentIdsRogue = rogueScanItems.value.map(item => item.garment_id).join(',');
  let garmentIdsScanned = scannedItems.value.map(item => item.garment_id).join(',');
  RFIDService.resetProcessingScan(currentOrderId, garmentIdsRogue, garmentIdsScanned)
      .then(response => {
        rogueScanItems.value = [];
        scannedItems.value = [];
        tagsScanned.value = [];
        countScannedItems.value = 0;
        countRogueScannedItems.value = 0;
      })
      .catch(e => {
        console.log(e);
      });

  
  
}
function updateOrderAction() {
  forcePermitted.value = false;
  let epos_userid = VueCookies.get('epos2_userid');
  RFIDService.checkManagerByPin(epos_userid, uniquepw.value)
    .then(response => {

      if (response.data.success === true) {
        let newDateValue = "";
        if(updateDateType.value === "datecollect") newDateValue = formatDateYMD(orderDetails.value.datecollect);
        else if(updateDateType.value === "datedue") newDateValue = formatDateYMD(orderDetails.value.datedue);

        OrderService.updateOrder(currentOrderId, updateDateType.value, newDateValue, uniquepw.value)
          .then(response => {
            if (response.data.success === true) {
              console.log("Order updated successfully");
              error_message.value = "";
              uniquepw.value = "";
              closeModal(showUpdateOrderModal);
              loadOrderDetails();
            } else {
              console.log("Error updating order", response.data.message);
              error_message.value = response.data.message;
              forcePermitted.value = response.data.data?.force_permitted || false;
            }
          })
          .catch(e => {
            forcePermitted.value = e.response.data.data?.force_permitted || false;
            console.log("Force permitted?", e.response.data, forcePermitted.value);
            error_message.value = e.response.data.message;
            console.log(e);
          });
      } else {
        console.log("Incorrect Manager Pin");
        error_message.value = "Incorrect Manager PIN";
        return false
      }
    })
    .catch(e => {
      error_message.value = "Incorrect Manager PIN X";
      console.log(e);
      return false
    });
}

function confirmOrderUpdate() {

    let newDateValue = "";
    if(updateDateType.value === "datecollect") newDateValue = formatDateYMD(orderDetails.value.datecollect);
    else if(updateDateType.value === "datedue") newDateValue = formatDateYMD(orderDetails.value.datedue);

    OrderService.updateOrder(currentOrderId, updateDateType.value, newDateValue, uniquepw.value, true)
        .then(response => {
          if (response.data.success === true) {
            console.log("Order updated successfully");
            error_message.value = "";
            uniquepw.value = "";
            closeModal(showUpdateOrderModal);
            loadOrderDetails();
          } else {
            console.log("Error updating order", response.data.message);
            error_message.value = response.data.message;
          }
        })
        .catch(e => {
          error_message.value = e.response.data.message;
          console.log(e);
        });
}

const showOrderHistory = async () => {
  try {
    const orderStatusResponse = await OrderService.getOrderHistory(parseInt(router.currentRoute.value.params.id));
    console.log("Order Status:", orderStatusResponse);
    
    if (orderStatusResponse.data.success == true) {
      orderStatusItems.value = orderStatusResponse.data.data.logs
      .filter(log => log.status_type.statuscat === "PRO")
      .map(log => ({
        status: log.status_type.statustype || 'Unknown Status',
        date: formatFullDateEN(log.status_time),
        user: log.epos_user_name || 'Unknown User'
      }));
      openModal(showOrderHistoryModal);
    }
  } catch (error) {
    console.error("Error loading order details:", error);
  }
}


function processOrderAction() {
    let epos_userid = VueCookies.get('epos2_userid');
    RFIDService.checkUserUniquepw(epos_userid, uniquepw.value)
      .then(response => {
        if (response.data.success === true) {
               
            RFIDService.processOrder(currentOrderId)
                .then(response => {
                  stopScan();
                  canStopScan.value = false;
                  canStartScan.value = true;
                  newBatchId.value = 1;

                  canProcess.value = false;

                  showProcessMessage.value = false;
                  processMessage.value = "";
                  showProcessErrors.value = false;
                  processErrors.value = "";
                  rogueScanItems.value = [];
                  scannedItems.value = [];
                  tagsScanned.value = [];
                  countScannedItems.value = 0;
                  countRogueScannedItems.value = 0;

                  error_message.value = "";
                  uniquepw.value = "";
                  processComplete.value = true;
                  //closeModal(showAlertMessagesModal);

                })
                .catch(e => {
                  console.log(e);
                });

          
        } else {
          console.log("Incorrect Manager Pin");
          error_message.value = "Incorrect Pin";
          return false
        }
      })
      .catch(e => {
        error_message.value = "Incorrect Pin";
        console.log(e);
        return false
      });
 
}
const confirmCompleteAction = () => {
  confirmComplete.value = false;
  processComplete.value = false;
}
const processOrder = async () => {
  processErrors.value = "";
  if (scannedItems.value.length === 0) {
    showProcessErrors.value = true;
    processErrors.value = "No items scanned. Please scan items before processing the order.";
    canProcess.value = false;
    return false;
  }
  openModal(showAlertMessagesModal);  
  
}
const printWhiteTicket = async () => {
  try {
    //let userid = VueCookies.get('epos2_userid');
   // const response = await OrderService.printWhiteTicket(currentOrderId, userid);
    const response = await OrderService.printServiceTickets(currentOrderId, {towel_folding:false, is_processing:true});
    console.log("Print White Ticket Response:", response);
  } catch (error) {
    console.error("Error printing white ticket:", error);
  }
};
const goTo = (pageSection, item=false) =>   {
  switch (pageSection) {
    case "Dashboard":
      window.open(
          "/rfid/processing-selection",
          "_self"
      );
      break;
    case "StartScan":
      setStartScan();
      startScan();
      break;
    case "StopScan":
      setStopScan();
      stopScan();
      break;
    case "Reset":
      setResetScan();
      resetScan();
      break;
    case "ProcessOrder":
      processOrder();
      break;
    case "EposOrder":
        window.open(
           "/orders/" + currentOrderId,
          "_self"
      );
      break;
    case "RogueTransactions":
      window.open(
          "/rfid/rogue-gallery/" + currentOrderId,
          "_self"
      );
      break;

  }
}

const loadOrderDetails = async () => {
  try {
    const orderDetailsResponse = await OrderService.getOrder(parseInt(router.currentRoute.value.params.id));
    console.log("Order Details:", orderDetailsResponse);
     /*if (response.data.status == "OK") {
      let orderDetails = response.data.result.details;
     }*/
    if (orderDetailsResponse.data.success == true) {
      orderDetails.value = orderDetailsResponse.data.data.orders[0];
      orderDetails.value.datecollect = formatDateYMD(orderDetails.value.datecollect);
      orderDetails.value.datedue = formatDateYMD(orderDetails.value.datedue);
      console.log("Order Details Value:", orderDetails.value);
    }
  } catch (error) {
    console.error("Error loading order details:", error);
  }
};
onMounted(async () => {
  showAlertMessagesModal.value = new bootstrap.Modal('#showAlertMessagesModal', {})
  showUpdateOrderModal.value = new bootstrap.Modal('#showUpdateOrderModal', {})
  showOrderHistoryModal.value = new bootstrap.Modal('#showOrderHistoryModal', {})
  loadOrderDetails();
});
</script>

<style scoped>
a.white {
  color: white;
  text-decoration: underline;
  font-weight: bold;
}
.right-pipeline {
  border-right: solid 1px;
}
.main-section > h1:first-child {
  background: var(--process-bg-color);
}
.error-message {
  color: var(--red-color);
  font-weight: bold;
}

</style>
